import { render, staticRenderFns } from "./TournamentDetail.vue?vue&type=template&id=fa70afb6"
import script from "./TournamentDetail.vue?vue&type=script&lang=js"
export * from "./TournamentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports